import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faInstagram, faTiktok, faFacebook, faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { faEnvelope, faChevronUp, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-help',
  standalone: true,
  imports: [CommonModule, FontAwesomeModule, TranslateModule],
  templateUrl: './help.component.html',
  styleUrl: './help.component.scss'
})
export class HelpComponent implements OnInit {
  faInstagram = faInstagram;
  faTiktok = faTiktok;
  faFacebook = faFacebook;
  faMail = faEnvelope;
  faWhatsapp = faWhatsapp;
  faChevronUp = faChevronUp;
  faChevronDown = faChevronDown;

  questions: { question: string; answer: string; isExpanded?: boolean }[] = [];

  constructor(private translate: TranslateService) {}

  ngOnInit(): void {
    this.loadQuestions();
    this.translate.onLangChange.subscribe(() => this.loadQuestions());
  }

  private loadQuestions(): void {
    const raw = this.translate.instant('help.questions');
    if (Array.isArray(raw)) {
      this.questions = raw.map((item: any) => ({
        question: item.q,
        answer: item.a,
        isExpanded: false,
      }));
    }
  }

  toggleQuestion(question: any) {
    question.isExpanded = !question.isExpanded;
  }
}
